export default __webpack_public_path__ + "static/media/hht1_ep17_minisitcom_04.7e5d8f16.png";